module.exports = __webpack_public_path__ + "img/bitbox02-locked.1309a8a7.png";